import {
  Button, Checkbox, Col, Collapse, Flex, Input, Row, Typography,
} from 'antd';
import { SearchIcon } from 'assets/icons';
import React, { useState } from 'react';

function ModalFilterBox({
  filter = [], setFilters, options, title,
}) {
  const [searchOptions, setSearchOptions] = useState(options);
  const getHeaderSelectOption = () => (
    <Flex align="center" gap={4}>
      <span>Select</span>
      <Button type="link" size="small" onClick={selectAll}>
        All
      </Button>
      <Button type="link" size="small" onClick={clearAll}>
        None
      </Button>
    </Flex>
  );

  const clearAll = (e) => {
    e.stopPropagation();
    setFilters([]);
  };

  const selectAll = (e) => {
    e.stopPropagation();
    const allOptions = options.map((option) => String(option.value));
    setFilters(allOptions);
  };

  const onOptionChange = (option) => {
    const selected = option?.target.value;
    setFilters(option.target.checked ? [...filter, selected] : filter.filter((f) => f !== selected));
  };

  const onSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchOptions(options.filter((option) => option.label?.toLowerCase().indexOf(searchTerm?.toLowerCase()) !== -1));
  };

  return (
    <Collapse
      defaultActiveKey={[1]}
      ghost
      items={[{
        key: 1,
        label: (<Flex justify="space-between" align="center">
          <Typography.Text>
            {title}
          </Typography.Text>
          {getHeaderSelectOption()}
        </Flex>),
        children: (
          <div className="modal-filter-container">
            <Input
              placeholder="Search"
              prefix={<SearchIcon className="modal-search-icon" />}
              variant="borderless"
              onChange={onSearch}
              className="modal-search-input"
            />
            <div className="filter-option-container">
              <Checkbox.Group style={{ width: '100%' }} value={filter}>
                <Row>
                  {searchOptions?.map((option) => (
                    <Col span={12} className="filter-option" key={option.value}>
                      <Checkbox value={String(option.value)} onChange={onOptionChange}>{option.label}</Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </div>
          </div>
        ),
      }]}
    />
  );
}

export default ModalFilterBox;
